import React from 'react';
import style from "./style.scss";
import Image from '../../atoms/Image';

const FeedbackHeader = ({ title, subTitle, imgSrc }) => {
    return (
        <>
            <div className={style['info-txt']}>
                {title}
                <div>{subTitle}</div>
            </div>
            <div className={style['feedback-img-holder']}>
                <Image Src={imgSrc} />
            </div>
        </>
    )
}

export default FeedbackHeader